module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_8023.c9c06931.png";